import { View } from 'react-native'

import ModalWide from '@ui/components/Modal/variants/ModalWide'
import AvatarConsultantSection from '@screens/intro/avatar/sections/Consultant'
import AvatarDealsSection from '@screens/intro/avatar/sections/Deals'

interface Props {
  open: boolean
  close: () => void
  onStartGuidance: () => void
  onBrowseDeals: () => void
}

export default function AvatarStartModal({
  open,
  close,
  onStartGuidance,
  onBrowseDeals,
}: Props) {
  return (
    <ModalWide open={open} close={close} hideBottomSpace>
      <View className="flex flex-col gap-6 p-8">
        <AvatarConsultantSection onPress={onStartGuidance} />
        <AvatarDealsSection onPress={onBrowseDeals} />
      </View>
    </ModalWide>
  )
}
